<template>
    <RatesTableFormCommon :hideResidenceType="true" />
</template>
